import { ViCarePlan } from './purchases.model';

export class MockedVicarePlans {
  mock(): ViCarePlan[] {
    return [
      {
        product: 'vicare',
        plan: 'Basic',
        scope: 'user',
        features: [
          'AdvancedSystemConfiguration',
          'AmazonAlexa',
          'BasicStatistics',
          'BuildInWizards',
          'CustomSchedules',
          'FeedbackAndSupport',
          'FullControl',
          'HolidayMode',
          'OutsideTemperatureHistory',
          'QuickSelections',
          'RealTimeNotification',
          'RemoteService',
          'ViCareDefaultAccess',
          'ViCareSmartClimate',
          'ViCareSmartClimateComponents',
          'WeatherForecast',
        ],
        properties: {},
        resourceId: '7b62ce20-c2a3-466d-8bea-32038edee9fa',
        active: true,
        isDefault: true,
      },
      {
        product: 'vicare',
        plan: 'VicarePrime',
        scope: 'user',
        features: [
          'AdvancedReports',
          'AdvancedSystemConfiguration',
          'AmazonAlexa',
          'BasicStatistics',
          'BuildInWizards',
          'ComparisonOfEnergyConsumption',
          'CustomSchedules',
          'DhwSavingsCalculator',
          'FamilyAndFriends',
          'FeedbackAndSupport',
          'ForecastOfEnergyConsumption',
          'FullControl',
          'HeatingCurveOptimiser',
          'HolidayMode',
          'IntelligentHeatControl',
          'OutsideTemperatureHistory',
          'QuickSelections',
          'RealTimeNotification',
          'RemoteService',
          'SmartClimateSavings',
          'SrcWindowOpenDetection',
          'ViCareDefaultAccess',
          'ViCareSmartClimate',
          'ViCareSmartClimateComponents',
          'WeatherForecast',
          'geofencing',
        ],
        properties: {},
        resourceId: '',
        active: false,
        isDefault: false,
      },
      {
        product: 'vicare',
        plan: 'DynamicAssistantBasic',
        scope: 'user',
        features: [
          'SettingsForOptimization',
          'OptimizationForHeatPump',
          'OptimizationForBatteryStorage',
        ],
        properties: {},
        resourceId: '5032c9ee-9421-44d9-9864-9db28b75184a',
        active: true,
        isDefault: false,
      },
    ];
  }
}
